<template>
  <audit-log />
</template>

<script>
  export default {
    name: 'GeneralAuditLog',

    components: {
      AuditLog: () => import('../components/AuditLog'),
    },
  }
</script>
